import * as React from 'react';
import { UIText1 } from '@cian/ui-kit';

import styles from './styles.module.css';

export const SuggestionTextItem: React.FC<{ children: React.ReactNode }> = props => {
  return (
    <li className={styles['item']} role="option" tabIndex={-1} data-testid="suggesttion-text-item">
      <UIText1 whiteSpace="pre-wrap" color="text-secondary-default">
        {props.children}
      </UIText1>
    </li>
  );
};
